import { createRoot } from 'react-dom/client';
import OrganonOrderingCart from './components/OrganonOrderingCart';
import OrganonOrderingCartMyOrderConfirmation from './components/OrganonOrderingCartMyOrderConfirmation';
import OrganonOrderingCartMyCheckout from './components/OrganonOrderingCartMyCheckout';
import OrganonOrderingCartMyOrder from './components/OrganonOrderingCartMyOrder';
import { CartProvider } from './context/CartProvider';

// Map root DOM IDs to components
const mountPoints = {
    'organonOrderingCartOrderConfirmation': OrganonOrderingCartMyOrderConfirmation,
    'organonOrderingCartMyCheckout': OrganonOrderingCartMyCheckout,
    'organonOrderingCartMyOrder': OrganonOrderingCartMyOrder,
};

// Wait for DOM to load
document.addEventListener('DOMContentLoaded', () => {
    // Render global cart container if present
    const globalCartContainer = document.getElementById('organonOrderingCartReact');
    if (globalCartContainer) {
        const root = createRoot(globalCartContainer);
        root.render(
            <CartProvider>
                <OrganonOrderingCart />
            </CartProvider>
        );
    }

    // Render each page mount in its own root
    Object.entries(mountPoints).forEach(([id, Component]) => {
        const container = document.getElementById(id);
        if (container) {
            const root = createRoot(container);
            root.render(
                <CartProvider>
                    <Component />
                </CartProvider>
            );
        }
    });
});